<template>
  <v-layout column wrap>
    <v-flex class="mb-4 d-flex align-items-center">
      <div>
        <h1 class="d-inline-block vertical-align-middle">{{ $t('beneficiary-information-details') }}</h1>
      </div>
    </v-flex>
    <!-- Add/Edit LookUp beneficiaryInformationManagement -->
    <v-layout wrap>
      <beneficiary-information />
    </v-layout>
  </v-layout>
</template>

<script>
const BeneficiaryInformation = () => import('@/views/Disabilities/Shared/BeneficiaryInformation.vue');
export default {
  name: 'beneficiary-information-details',
  data: () => ({}),
  created() {},
  methods: {},
  components: {
    BeneficiaryInformation
  }
};
</script>
